import React, {useState} from 'react'
import style from './contactPage.module.css'
import { emaiService } from '../../api/emailApi'


const ContactPage = () => {
    const [formData,
        setFormData] = useState({name: '', email: '', phone: '', subject: '', message: ''})

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const fD = new FormData(e.currentTarget)
        // Logique d'envoi du formulaire
        const finalData = Object.fromEntries(fD)
        console.log("Le fd", fD)

        console.log("Final data ", finalData)

        // worker
         const resp = await emaiService.contactUs(finalData)
        console.log("La réponse ", resp)
        
    }

    const contactInfo = [
        {
            icon: "📧",
            title: "Email",
            value: "contact@get-conseil.com",
            link: "mailto:contact@get-conseil.com"
        }, {
            icon: "📱",
            title: "Téléphone",
            value: "055700404 | 064147653",
            link: "tel:+2420537505740"
        }, {
            icon: "📍",
            title: "Localisation",
            value: "Brazzaville",
            link: null
        }, {
            icon: "⏰",
            title: "Horaires",
            value: "Lun - Ven : 8h - 18h",
            link: null
        }
    ]

    const locations = [
        {
            city: "Brazzaville",
            address: "L’Avenue AUBERGE Gascogne 102, Makelékélé",
            description: "-"
        },
    ]

    return (
        <div className={style.mainContact}>

            {/* Hero Section */}
            <div className={style.heroSection}>
                <div className={style.containerHead}>
                    <h1>Contactez-nous</h1>
                    <p className={style.subtitle}>
                        Un projet ? Une question ? Nous sommes là pour vous écouter
                    </p>
                    <p className={style.description}>
                        Nous privilégions un rendez-vous initial formel et engageant. Ce premier contact
                        ne s’effectue pas par téléphone. À l’issue de cet échange, une rencontre avec
                        votre équipe dirigeante est organisée afin de définir les modalités d’une
                        collaboration future, en cohérence avec les besoins préalablement identifiés.
                    </p>
                </div>
            </div>

            {/* Contact Info Cards */}
            <div className={style.infoSection}>
                <div className={style.sectionContainer}>
                    <div className={style.infoGrid}>
                        {contactInfo.map((info, index) => (
                            <div key={index} className={style.infoCard}>
                                <div className={style.infoIcon}>{info.icon}</div>
                                <h3>{info.title}</h3>
                                {info.link
                                    ? (
                                        <a href={info.link} className={style.infoValue}>{info.value}</a>
                                    )
                                    : (
                                        <p className={style.infoValue}>{info.value}</p>
                                    )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Contact Form & Map Section */}
            <div className={style.formSection}>
                <div className={style.sectionContainer}>
                    <div className={style.formContainer}>
                        {/* Contact Form */}
                        <div className={style.formWrapper}>
                            <h2>Envoyez-nous un message</h2>
                            <p className={style.formIntro}>
                                Remplissez ce formulaire et nous vous répondrons dans les plus brefs délais
                            </p>
                            <form onSubmit={handleSubmit} className={style.contactForm}>
                                <div className={style.formGroup}>
                                    <label htmlFor="name">Nom complet *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="fullName"
                                        
                                        onChange={handleChange}
                                        required
                                        placeholder="Votre nom"/>
                                </div>

                                <div className={style.formGroup}>
                                    <label htmlFor="email">Email *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="uEmail"
                                        
                                        onChange={handleChange}
                                        required
                                        placeholder="votre.email@exemple.com"/>
                                </div>

                                <div className={style.formGroup}>
                                    <label htmlFor="phone">Téléphone</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        
                                        onChange={handleChange}
                                        placeholder="+242 XX XXX XX XX"/>
                                </div>

                                <div className={style.formGroup}>
                                    <label htmlFor="subject">Sujet *</label>
                                    <select
                                        id="subject"
                                        name="subject"
                                        
                                        onChange={handleChange}
                                        required>
                                        <option value="">Sélectionnez un sujet</option>
                                        <option value="conseil">Conseil stratégique</option>
                                        <option value="dev">Développement web</option>
                                        <option value="formation">Formation</option>
                                        <option value="audit">Audit technique</option>
                                        <option value="autre">Autre demande</option>
                                    </select>
                                </div>

                                <div className={style.formGroup}>
                                    <label htmlFor="message">Message *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="6"
                                        placeholder="Décrivez votre projet ou votre besoin..."></textarea>
                                </div>

                                <button type="submit" className={style.submitBtn}>
                                    Envoyer le message
                                </button>
                            </form>
                        </div>

                        {/* Quick Contact */}
                        <div className={style.quickContact}>
                            <h3>Besoin d'une réponse rapide ?</h3>
                            <p>Contactez-nous directement via ces canaux :</p>

                            <div className={style.quickLinks}>
                                <a href="tel:+242061234567" className={style.quickLink}>
                                    <span>📞</span>
                                    <div>
                                        <strong>Appelez-nous</strong>
                                        <p>+242 064147653 | 055700404</p>
                                    </div>
                                </a>

                                <a href="https://wa.me/065543291" className={style.quickLink}>
                                    <span>💬</span>
                                    <div>
                                        <strong>WhatsApp</strong>
                                        <p>Discussion instantanée</p>
                                    </div>
                                </a>

                                <a href="mailto:contact@get-conseil.com" className={style.quickLink}>
                                    <span>✉️</span>
                                    <div>
                                        <strong>Email direct</strong>
                                        <p>contact@get-conseil.com</p>
                                    </div>
                                </a>
                            </div>

                            <div className={style.socialLinks}>
                                <h4>Suivez-nous</h4>
                                <div className={style.socialIcons}>
                                    <a href="/lien-link-dn" aria-label="LinkedIn">in</a>
                                    <a href="/facebook" aria-label="Facebook">f</a>
                                    <a href="/twiter" aria-label="Twitter">𝕏</a>
                                    <a href="/instagram" aria-label="Instagram">📷</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Locations Section */}
            <div className={style.locationsSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Nos Implantations</h2>
                    <div className={style.locationsGrid}>
                        {locations.map((location, index) => (
                            <div key={index} className={style.locationCard}>
                                <div className={style.locationIcon}>📍</div>
                                <h3>{location.city}</h3>
                                <p className={style.locationAddress}>{location.address}</p>
                                <p className={style.locationDescription}>{location.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* FAQ Section */}
            <div className={style.faqSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Questions Fréquentes</h2>
                    <div className={style.faqGrid}>
                        <div className={style.faqCard}>
                            <h3>Quels sont vos délais de réponse ?</h3>
                            <p>Nous nous engageons à répondre à toutes les demandes dans un délai de 24 à 48
                                heures ouvrables.</p>
                        </div>
                        <div className={style.faqCard}>
                            <h3>Proposez-vous des consultations gratuites ?</h3>
                            <p>Oui, nous offrons un premier échange gratuit de 30 minutes pour discuter de
                                votre projet.</p>
                        </div>
                        <div className={style.faqCard}>
                            <h3>Dans quelles villes intervenez-vous ?</h3>
                            <p>Nous sommes présents à Brazzaville, très prochainement à Pointe-Noire et Dolisie, avec possibilité
                                d'intervention nationale.</p>
                        </div>
                        <div className={style.faqCard}>
                            <h3>Comment se déroule un projet type ?</h3>
                            <p>Analyse des besoins, test ,proposition, développement,
                                déploiement continu.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactPage